import { render, staticRenderFns } from "./AparelhosJupiter.vue?vue&type=template&id=22338c90&scoped=true"
import script from "./AparelhosJupiter.vue?vue&type=script&lang=js"
export * from "./AparelhosJupiter.vue?vue&type=script&lang=js"
import style0 from "./AparelhosJupiter.vue?vue&type=style&index=0&id=22338c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22338c90",
  null
  
)

export default component.exports